<template>
  <div class="panel-yellow">
    <i class="fas fa-bell-exclamation icon" />
    <p class="content">
      {{ $store.state.actionMessage.message }}
    </p>
  </div>
</template>

<style scope>
.panel-yellow .content {
  color: #af6708;
  margin-left: 12px;
  text-align: left;
}
.panel-yellow .icon {
  font-size: 22px;
  color: #af6708;
  margin-top: 3px;
}
.panel-yellow {
  display: flex;
  flex-direction: row;
  padding: 16px 25px 5px 18px;
  background: #fff5e8;
  border: 1px solid #fdac41;
  border-radius: 4px;
  margin: 3px;
}
</style>

<script>
import Store from '@/store/index';
export default {
  name: 'CustomInnerPageMessage',
  meta: {
    description: 'Componente para mostrar mensajes de alertas.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  computed: {
    getMessage() {
      return Store.state.actionMessage.message;
    },
    getIsVisible() {
      return Store.state.actionMessage.visible;
    },
  },
};
</script>
